module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_2-61ec16275f5e935827f16da4219f6d6f.png";